import React, { useState, useEffect, useRef } from "react";
import { ComposableMap, Geographies, Geography, ZoomableGroup } from "react-simple-maps";
import * as topojson from 'topojson-client';
import { geoMercator, geoCentroid } from "d3-geo";
import { useSpring, animated } from '@react-spring/web';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const IndiaMap = () => {
  const [indiaData, setIndiaData] = useState(null);
  const [zoom, setZoom] = useState(1);
  const [selectedState, setSelectedState] = useState(null);
  const [highlightPosition, setHighlightPosition] = useState(null);
  const [stateInfo, setStateInfo] = useState({});
  const mapContainerRef = useRef(null);
  const [curvePaths, setCurvePaths] = useState([]); // Store multiple curves
  const [pointers, setPointers] = useState([]);
  const [mapCenter, setMapCenter] = useState([80, 20]);
  const [currentPathIndex, setCurrentPathIndex] = useState(0); // Track which path is animating
  const [animationProgress, setAnimationProgress] = useState(0); // Animation progress for the current path
  const projection = geoMercator().scale(750).center(mapCenter);
  const [infoBoxData, setInfoBoxData] = useState(null); // To hold the clicked state's data
  const [infoBoxPosition, setInfoBoxPosition] = useState([0, 0]); // To hold position of the info box
  const mapRef = useRef(null); // Reference to the map container
  const [curveNumbers, setCurveNumbers] = useState([]);
  const [completedConnections, setCompletedConnections] = useState(0);
  const [totalConnections, setTotalConnections] = useState(0);
  const counterRef = useRef(1);  // Initialize the counter to 1
  const [stateConnections, setStateConnections] = useState([]);
  // const [curveNumberCounter, setCurveNumberCounter] = useState(1);
  const [statesGeoJson, setStatesGeoJson] = useState(null);
  const [apiData, setApiData] = useState([]);

  useEffect(() => {
    projection.scale(750 * zoom);
  }, [zoom]);
  const API_URL =
    "https://tagprotect.in/api/service1/api/tags/tag-data/1B4B5";
  const fetchData = async () => {
    try {
      const response = await fetch(API_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (!response.ok) {
        throw new Error(`Error fetching data: ${response.status}`);
      }
      const data = await response.json();
      setApiData(data);
      // Transform API data into desired format
      const transformedConnections = data.reduce((acc, item) => {
        const start = item.fromLocation;
        const end = item.toLocation;

        // Find if the start location already exists
        const existing = acc.find((conn) => conn.start === start);
        if (existing) {
          existing.ends.push(end);
        } else {
          acc.push({ start, ends: [end] });
        }
        return acc;
      }, []);

      setStateConnections(transformedConnections);
    } catch (error) {
      console.error("Failed to fetch connections:", error);
    }
  };
  useEffect(() => {
    fetchData(); // Call the API when the component mounts
  }, []);
  useEffect(() => {
    fetch("/india.json")
      .then((response) => response.json())
      .then((topoJsonData) => {
        const statesGeoJson = topojson.feature(topoJsonData, topoJsonData.objects.states);
        setIndiaData({ states: statesGeoJson });
        setStatesGeoJson(statesGeoJson);
        // Initialize random state info (optional)
        const initialStateInfo = statesGeoJson.features.reduce((acc, state) => {
          acc[state.properties.st_nm] = {
            population: Math.floor(Math.random() * 10_000_000),
            area: Math.floor(Math.random() * 100_000),
          };
          return acc;
        }, {});
        setStateInfo(initialStateInfo);

        // Define state connections
        // const stateConnections = [
        //     { start: "Madhya Pradesh", ends: ["Delhi"] },
        //     { start: "Delhi", ends: ["Rajasthan", "Odisha", "Bihar"] },
        //     { start: "Madhya Pradesh", ends: ["Tamil Nadu"]},
        //     { start: "Rajasthan", ends: ["Karnataka", "Kerala"] },
        //     { start: "Kerala", ends: ["Gujarat"] },
        //   ];
        let curveNumberCounter = 1; // Initialize a persistent counter for curve numbers

        // const animateConnections = async () => {
        //   for (let i = 0; i < stateConnections.length; i++) {
        //     const connection = stateConnections[i];

        //     await new Promise((resolve) => {
        //       setTimeout(async () => {
        //         for (let j = 0; j < connection.ends.length; j++) {
        //           const endState = connection.ends[j];

        //           await new Promise((innerResolve) => {
        //             drawCurves(statesGeoJson, connection.start, [endState], curveNumberCounter);
        //             setCurveNumberCounter((prev) => prev + 1); // Increment the counter
        //             innerResolve();
        //           });

        //           await new Promise((resolveDelay) => setTimeout(resolveDelay, 500)); // Delay between curves
        //         }

        //         resolve();
        //       }, 1000); // Delay before moving to the next connection
        //     });
        //   }
        // };





      });
  }, []);
  let curveNumberCounter = 1; // Initialize a persistent counter for curve numbers

  const animateConnections = async () => {
    for (let i = 0; i < stateConnections.length; i++) {
      const connection = stateConnections[i];

      await new Promise((resolve) => {
        setTimeout(async () => {
          // Here, we make sure the start and end locations are passed correctly
          // const startState = connection.start;
          //const endStates = connection.ends;

          for (let j = 0; j < connection.ends.length; j++) {
            // const startState = connection.start;  // From API (Assam)
            const endState = connection.ends[j];
            const startState = i === 0 ? endState : connection.start; // Reverse order for the first connection
            const endStateReversed = i === 0 ? connection.start : endState; // Reverse order for the first connection
            // To API (Goa)
            console.log(startState);
            // Draw the curve for the current connection
            await new Promise((innerResolve) => {
              drawCurves(statesGeoJson, startState, [endStateReversed], curveNumberCounter);
              innerResolve();
              curveNumberCounter++; // Increment the curve number after each curve is drawn
            });

            // Ensure a delay between drawing each curve (optional)
            await new Promise(resolveDelay => setTimeout(resolveDelay, 500)); // Delay between individual curves
          }

          resolve(); // Resolve once all curves for this connection are drawn
        }, 0); // Delay before moving to the next connection
      });
    }
  };
  useEffect(() => {
    if (stateConnections.length > 0 && statesGeoJson) {
      animateConnections(); // Start animation after connections are set
    }
  }, [stateConnections, statesGeoJson]);
  const getMidpoint = (path) => {
    // Match quadratic curve path (M x1,y1 Q cx,cy x2,y2)
    const match = path.match(/M\s*(-?\d+\.?\d*),\s*(-?\d+\.?\d*)\s*Q\s*(-?\d+\.?\d*),\s*(-?\d+\.?\d*)\s*(-?\d+\.?\d*),\s*(-?\d+\.?\d*)/);

    if (match) {
      const [, x1, y1, cx, cy, x2, y2] = match.map(Number);

      // Calculate the midpoint using quadratic Bezier formula (t = 0.5 for midpoint)
      const t = 0.5;
      const mx = (1 - t) ** 2 * x1 + 2 * (1 - t) * t * cx + t ** 2 * x2;
      const my = (1 - t) ** 2 * y1 + 2 * (1 - t) * t * cy + t ** 2 * y2;

      return { x: mx, y: my };
    }

    return { x: 0, y: 0 }; // Fallback for invalid path
  };

  const drawCurves = (geoJson, startState, endStates, curveNumberCounter) => {
    const startFeature = geoJson.features.find((state) => state.properties.st_nm === startState);

    if (startFeature) {
      const [startX, startY] = projection(geoCentroid(startFeature));

      endStates.forEach((endState, index) => {
        const endFeature = geoJson.features.find((state) => state.properties.st_nm === endState);

        if (endFeature) {
          const [endX, endY] = projection(geoCentroid(endFeature));

          // Introduce a dynamic offset based on the index to differentiate overlapping curves
          const offsetMultiplier = 30; // Change this value to adjust spacing
          const verticalOffset = index * offsetMultiplier;

          const midX = (startX + endX) / 2;
          const midY = Math.min(startY, endY) - 50 - verticalOffset;

          // Debugging the coordinates
          console.log(`Start (${startX}, ${startY}), End (${endX}, ${endY}), Mid (${midX}, ${midY})`);

          // Path: Make sure the start and end coordinates are respected
          const path = `M${startX},${startY} Q${midX},${midY} ${endX},${endY}`;

          // Add the curve path to state
          setCurvePaths((prevPaths) => [
            ...prevPaths,
            { path, curveNumber: curveNumberCounter },
          ]);

          // Add start and end points
          setPointers((prev) => [
            ...prev,
            { x: startX, y: startY, isStart: true },
            { x: endX, y: endY, isStart: false },
          ]);

          setCompletedConnections((prev) => prev + 1);
        }
      });
    }
    console.log(`Drawing curve from ${startState} to ${endStates}`);
  };


  useEffect(() => {
    if (curvePaths.length > 0) {
      const numbers = [];
      let counter = 1; // Start the counter at 1
      curvePaths.forEach(() => {
        numbers.push({
          curveNumber: counter, // Sequential numbering
          // Optional: you could also store x, y here if needed
        });
        counter++; // Increment for the next curve
      });
      setCurveNumbers(numbers); // Update state with curve numbers
    }
  }, [curvePaths]);

  const handleNumberClick = (geo) => {
    const stateName = geo.properties.st_nm;
    const [x, y] = geoCentroid(geo);

    // Set the info box data
    setInfoBoxData({
      name: stateName,

    });

    // Position the info box above the clicked state
    const [px, py] = projection([x, y]);
    setInfoBoxPosition([px, py - 20]);
    console.log("InfoBox Position:", infoBoxPosition); // Adjust the offset to position it above the state
  };

  if (!indiaData) return <div>Loading...</div>;
  const adjustedPosition = (x, y) => {
    // Ensure x and y are numbers and not undefined
    const adjustedY = y < 20 ? 20 : y;
    const adjustedX = x < 20 ? 20 : x;

    const maxX = window.innerWidth - 100;
    const maxY = window.innerHeight - 100;

    const finalX = adjustedX > maxX ? maxX : adjustedX;
    const finalY = adjustedY > maxY ? maxY : adjustedY;

    console.log('Adjusted Position:', finalX, finalY); // Log adjusted position values
    return [finalX, finalY];
  };

  // Call adjustedPosition only when infoBoxPosition is properly set
  console.log('Current InfoBox Position:', infoBoxPosition); // Log to check if position is set correctly
  const [adjustedX, adjustedY] = adjustedPosition(infoBoxPosition[0], infoBoxPosition[1]);
  return (
    <div style={{ width: "90%", height: "700px", position: "relative", margin: "0 auto" }}>
      <ComposableMap
        projection={projection}
        style={{ width: "170%", height: "120%", marginLeft: "-170px" }}
      >
        <ZoomableGroup zoom={zoom} onZoom={(newZoom) => setZoom(newZoom)} center={mapCenter}>
          <Geographies geography={indiaData.states}>
            {({ geographies }) =>
              geographies.map((geo) => {
                const stateName = geo.properties.st_nm;
                const [centroidX, centroidY] = geoCentroid(geo);
                const [x, y] = projection([centroidX, centroidY]);
                const stateColor = "#B0C4DE";
                return (
                  <React.Fragment key={geo.rsmKey}>
                    <Geography
                      geography={geo}
                      //onClick={() => handleNumberClick(geo)}
                      style={{
                        default: { fill: "#1E90FF", stroke: "#000", strokeWidth: 0.5, outline: "none" },
                        hover: { fill: "#B0C4DE", outline: "none" },
                        pressed: { fill: "#FFD700", outline: "none" },
                      }}
                    />
                    <text
                      x={x}
                      y={y}
                      fontSize={9}
                      fill="#000"
                      textAnchor="middle"
                      alignmentBaseline="middle"
                      style={{ pointerEvents: "none" }}
                    >
                      {stateName}
                    </text>
                  </React.Fragment>
                );
              })
            }
          </Geographies>

          {curvePaths.map((curve, index) => {
            // Get the midpoint for the curve
            const { x, y } = getMidpoint(curve.path);

            // Get the curve number from the curveNumbers array
            const curveNumber = curve.curveNumber;
            const curveData = apiData.find(item => item.number === curveNumber);
            console.log(curveData);

            return (
              <React.Fragment key={index}>
                {/* Render the curve */}
                <path
                  d={curve.path}
                  className="animated-path"
                  fill="none"
                  stroke="#FFFF" // Curve color
                  strokeWidth={2}
                  style={{
                    strokeDasharray: `${curve.length || 0}`,
                    strokeDashoffset:
                      index === currentPathIndex
                        ? `${curve.length - animationProgress || 0}`
                        : curve.length,
                    transition: "stroke-dashoffset 0.3s linear",
                  }}
                />

                {/* Render the circle at the midpoint */}
                <circle
                  cx={x}
                  cy={y}
                  r={10} // Radius of the circle
                  fill="#FFF" // Background color of the circle
                  stroke="#000" // Border color of the circle
                  strokeWidth={1}
                  onMouseEnter={() => {
                    // Show amount on hover
                    console.log("Event Triggered, Curve Data:", curveData);
                    if (curveData) {
                      setInfoBoxData({
                        amount: curveData.amount ? `₹ ${curveData.amount}` : null,
                        fromLocation: curveData.fromLocation || null,
                        toLocation: curveData.toLocation || null,
                      });
                    } else {
                      console.warn("curveData is null or undefined!");
                    }
                    setInfoBoxPosition([x, y - 20]);
                  }}
                  // onClick={() => {
                  //   // You can also show details on click if desired
                  //   setHighlightPosition([x, y]);
                  //   setInfoBoxData({
                  //     amount: curveData?.amount || "N/A",
                  //   });
                  // }}

                  onMouseLeave={() => {
                    // Hide the info box on mouse leave
                    //setInfoBoxData(null);
                  }}
                />

                {/* Render the curve number inside the circle */}
                <text
                  x={x}
                  y={y}
                  fontSize={10}
                  fill="#000"
                  textAnchor="middle"
                  alignmentBaseline="middle"
                  style={{ pointerEvents: "none" }}>
                  {curveNumber} {/* Display the sequential number */}
                </text>
              </React.Fragment>
            );
          })}
          {pointers.map((point, index) => {
            // Find the corresponding state for this pointer
            const stateFeature = indiaData.states.features.find((feature) => {
              const [cx, cy] = projection(geoCentroid(feature));
              return Math.abs(cx - point.x) < 2 && Math.abs(cy - point.y) < 2; // Match coordinates within a small range
            });

            const stateName = stateFeature?.properties.st_nm || "Unknown";

            return (
              <circle
                key={index}
                cx={point.x}
                cy={point.y}
                r={5}
                fill={point.isStart ? "red" : "red"}
                stroke="#000"
                strokeWidth={1}
                onClick={() => {
                  setInfoBoxData({
                    name: stateName,
                    //amount:curveData.amount
                  });

                  // Position the info box above the clicked pointer
                  setInfoBoxPosition([point.x, point.y - 20]);
                }}

              />
            );
          })}
          {highlightPosition && (
            <foreignObject
              x={highlightPosition[0] - 15}
              y={highlightPosition[1] - 20}
              width={25}
              height={25}
            >
              {/* <LocationOnIcon style={{ fontSize: 25, color: "#FF0000" }} /> */}
            </foreignObject>
          )}
        </ZoomableGroup>
      </ComposableMap>
      <svg style={{ width: 0, height: 0, position: "absolute" }}>
        <defs>
          <filter id="glowEffect" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="10" result="blur" />
            <feBlend in="SourceGraphic" mode="normal" />
          </filter>
        </defs>
      </svg>
      {infoBoxData && (
        console.log("Rendering InfoBox"),

        <div
          style={{
            position: 'absolute',
            top: adjustedX,
            left: adjustedY,
            border: "1px solid red",
            backgroundColor: 'white',
            padding: '10px', // Adjust the padding to add some space inside
            borderRadius: '5px',
            boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
            zIndex: 10,
            transform: 'translate(-50%, -100%)', // Adjust to center above the circle
            minWidth: '100px', // Ensure it doesn't shrink too small
            minHeight: '80px', // Ensure it doesn't shrink too small
            maxWidth: '300px', // Optional, limit the maximum width
            maxHeight: '200px', // Optional, limit the maximum height
            overflow: 'auto', // Ensures content doesn't overflow the box
          }}
        >
          <h3 style={{ margin: '0 0 5px 0' }}>From: {infoBoxData.fromLocation || 'Unknown'}</h3>
          <h3 style={{ margin: '0 0 5px 0' }}>To: {infoBoxData.toLocation || 'Unknown'}</h3>
          <p style={{ margin: '0 0 5px 0' }}>Amount: {infoBoxData.amount || 'N/A'}</p>
          <button
            onClick={() => setInfoBoxData(null)} // Close the info box
            style={{
              position: 'absolute',
              top: '-13px',
              right: '-23px',
              background: 'none',
              border: 'none',
              fontSize: '16px',
              fontWeight: 'bold',
              color: '#000',
              cursor: 'pointer',
            }}
            aria-label="Close"
          >
            ×
          </button>
        </div>

      )}
      {console.log(infoBoxData)}
      {console.log("InfoBox Position:", infoBoxPosition)}



    </div>
  );
};

export default IndiaMap;

